<template>
  <svg width="18"
       height="19"
       viewBox="0 0 18 19"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M16.8311 6.8418C17.4023 6.8418 17.71 6.52539 17.71 5.9541V3.81836C17.71 1.9375 16.7256 0.953125 14.8184 0.953125H12.6826C12.1113 0.953125 11.7949 1.26074 11.7949 1.83203C11.7949 2.39453 12.1113 2.70215 12.6826 2.70215H14.7041C15.5039 2.70215 15.9609 3.12402 15.9609 3.97656V5.9541C15.9609 6.52539 16.2686 6.8418 16.8311 6.8418ZM1.16016 6.8418C1.73145 6.8418 2.03027 6.52539 2.03027 5.9541V3.97656C2.03027 3.12402 2.47852 2.70215 3.28711 2.70215H5.30859C5.87988 2.70215 6.19629 2.39453 6.19629 1.83203C6.19629 1.26074 5.87988 0.953125 5.30859 0.953125H3.17285C1.27441 0.953125 0.28125 1.92871 0.28125 3.81836V5.9541C0.28125 6.52539 0.597656 6.8418 1.16016 6.8418ZM9 9.3291C10.3535 9.33789 11.4521 8.17773 11.4521 6.64844C11.4521 5.21582 10.3535 4.0293 9 4.0293C7.6377 4.0293 6.54785 5.21582 6.54785 6.64844C6.54785 8.17773 7.6377 9.32031 9 9.3291ZM4.7373 14.4971H13.2627C13.6846 14.4971 13.8955 14.207 13.8955 13.8203C13.8955 12.7744 12.3486 10.085 9 10.085C5.65137 10.085 4.10449 12.7744 4.10449 13.8203C4.10449 14.207 4.31543 14.4971 4.7373 14.4971ZM3.17285 18.3818H5.30859C5.87988 18.3818 6.19629 18.0654 6.19629 17.5029C6.19629 16.9404 5.87988 16.624 5.30859 16.624H3.28711C2.47852 16.624 2.03027 16.2109 2.03027 15.3584V13.3809C2.03027 12.8096 1.72266 12.4932 1.16016 12.4932C0.588867 12.4932 0.28125 12.8096 0.28125 13.3809V15.5166C0.28125 17.3975 1.27441 18.3818 3.17285 18.3818ZM12.6826 18.3818H14.8184C16.7256 18.3818 17.71 17.3975 17.71 15.5166V13.3809C17.71 12.8096 17.3936 12.4932 16.8311 12.4932C16.2598 12.4932 15.9609 12.8096 15.9609 13.3809V15.3584C15.9609 16.2109 15.5039 16.624 14.7041 16.624H12.6826C12.1113 16.624 11.7949 16.9404 11.7949 17.5029C11.7949 18.0654 12.1113 18.3818 12.6826 18.3818Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'PrimaryIcon',
  props: {
    width: {
      type: Number,
      default: 12
    },
    height: {
      type: Number,
      default: 13
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
